/* eslint-disable camelcase */
import { trackClick } from ".";
import ChaptersEnum from "./enums/chapters";
import LevelsEnum from "./enums/levels";
import ClickTypes from "./enums/click-types";
import ClicksEnum from "./enums/clicks";

export function trackClickHelp() {
  return trackClick({
    click_type: ClickTypes.Navigation,
    click: ClicksEnum.Help,
    click_chapter1: ChaptersEnum.MyAccount,
    site_level2: LevelsEnum.MyAccount,
  });
}
